export const EMPTY_DIV_ID = 'NewEventButtonAnchor';
export const EMPTY_DIV_ANCHOR = '#' + EMPTY_DIV_ID;
